import { queryOptions, useQuery } from '@tanstack/react-query'

import { useMeQuery } from '../../auth/services/useMeQuery'
import { intentionApi } from '../../intention/api/intentionApi'

export const getWatchmanDailyIntentionsOptions = ({ enabled }: { enabled: boolean }) =>
  queryOptions({
    queryKey: ['watchman_daily_intentions'],
    queryFn: ({ signal }) => intentionApi.getWatchmanIntentions({ signal }),
    retry: 0,
    staleTime: 60 * 1000 * 10, // 10 minutes
    refetchOnWindowFocus: true,
    enabled,
  })

export const useWatchmanDailyIntentionsQuery = () => {
  const { data: me, isLoading } = useMeQuery()
  const query = useQuery(getWatchmanDailyIntentionsOptions({ enabled: !!me && me.notifyWatchman !== 'none' }))
  return { ...query, isLoading: query.isLoading || isLoading }
}
